<script lang="ts" setup>

definePageMeta({layout: "home-design"});

const page: any = await usePage('/insights/');
const posts: any = await useAllPosts();

const postsPerPage = 9;
const additionalPostsPerPage = 3;

const newsletterSection = page?.pageBuilder?.sections?.find((item:any) => item.__typename === "PageBuilderSectionsNewsletterLayout");

const categories = [{
  label: 'View all', value: 'all'
}];

posts.value.forEach((post: any) => {
    let categoryArr: any = [];
    post.body?.categories?.nodes.forEach((category: {slug: string, name: string}) => {
        categoryArr.push(category.slug);
        const exists = categories.some(cat => cat.value === category.slug);
        if (!exists) {
            categories.push({
                label: category.name,
                value: category.slug
            });
        }
    });

    post.type = categoryArr;
});

// Filter options
const filters = ref(categories);
const activeFilter = ref('all');

const setActiveFilter = (filter) => {
  activeFilter.value = filter
}

const isLoading = ref(false);
const visibleCount = ref(postsPerPage);
const visiblePosts = computed(() => {

  const slicedPosts = posts.value.slice(0, visibleCount.value);

  if (activeFilter.value === 'all') {
    return slicedPosts;
  }

  return slicedPosts.filter(post => post.type.includes(activeFilter.value));
});

const loadMore = () => {
  if (visibleCount.value < posts.value.length && !isLoading.value) {

    isLoading.value = true;

    setTimeout(() => {
      visibleCount.value += additionalPostsPerPage;
      isLoading.value = false;
    }, 500);
  }
}

const hasMorePosts = computed(() => {
  return posts.value.length > visibleCount.value;
});

</script>
<template>
    <HeaderCover type="page" :page="page"/>
    <div class="section-spacer"></div>
    <div class="container-fluid insights-div">
      <div class="container-xl">
        <!-- Filter Tabs -->
        <div class="row mb-4">
          <div class="col-12">
              <div class="filter-tabs d-flex flex-wrap gap-md-4 gap-0">
                <div v-for="filter in filters" class="col-6 col-md-auto p-2 p-md-0">
                  <button 
                      :key="filter.value"
                      class="btn filter-btn rounded-pill"
                      :class="{ 'active': activeFilter === filter.value }"
                      @click="setActiveFilter(filter.value)"
                  >
                      {{ filter.label }}
                  </button>
                </div>
              </div>
              <hr class="text-primary filter-divider" />
          </div>
        </div>

        <div class="row g-5">
          <template v-for="post in visiblePosts">
            <Post :post="{
              title: post?.body?.title,
              uri: post?.body?.uri,
              date: post?.body?.date,
              slug: post?.body?.slug,
              tags: post?.body?.tags,
              categories: post?.body?.categories,
              id: post?.id,
              featuredImage: post?.body?.featuredImage
            }"/>
          </template>
        </div>

        <div class="section-spacer"></div>
        <div v-if="hasMorePosts" class="btn-action d-flex align-items-center justify-content-center">
            <button class="btn btn-primary rounded-pill" @click="loadMore" :disabled="isLoading">
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ isLoading ? 'LOADING...' : 'LOAD MORE' }}
            </button>
        </div>
        <div class="section-spacer"></div>
      </div>
    </div>
    <Newsletter  v-bind="newsletterSection"/>
</template>